import React, { useState } from 'react';
import "./LoginScreen.css";
import SignupScreen from './SignupScreen';
function LoginScreen() {

    const [signIn, setSignIn] = useState(false);

  return (
    <div className="loginScreen">
        <div className="loginScreen_background">
            <img
            className="loginScreen_logo"
            src="https://www.freepnglogos.com/uploads/netflix-logo-drawing-png-19.png"
            alt=""
            />
            <button 
            onClick={()=> setSignIn(true)}
            className="loginScreen_button">
                Sign In
            </button>

            <div className="loginScreen_gradient">
            </div>
            <div className="loginScreen_body">
                {signIn ?(
                    <SignupScreen />
                ) : (
                    <>
                <h1>WATCH MORE !! LOVE MORE ;).</h1>
                <h3>ANYTIME ANYWHERE...</h3>
                <div className="loginScreen_input">
                    <form>
                        <input type="email" placeholder="Email Address" />
                        <button 
                        onClick={()=> setSignIn(true)}
                        className="loginScreen_getStarted">
                            GET STARTED
                        </button>
                    </form>
                </div>
                </>
                )}
                
            </div>
        </div>
    </div>
  )
}

export default LoginScreen